import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";

const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-[#0B0D11] border-t border-white/10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-14">
          <div className="md:col-span-5">
            <Link to="/" data-testid="footer-logo" className="flex items-center gap-3">
              <img src="/assets/logo-mark.png" alt="HeroPhone Logo" className="h-12 w-auto" />
              <span className="font-display text-2xl font-extrabold italic uppercase tracking-wide">
                <span className="text-[#FFE600]">Hero</span>
                <span className="text-white">Phone</span>
              </span>
            </Link>
            <p className="mt-5 text-gray-400 text-sm leading-relaxed max-w-sm">
              Dein Ansprechpartner für Handy-Reparatur. Schnelle, zuverlässige und
              preiswerte Lösungen für Smartphones und Tablets.
            </p>
            <div className="mt-6 flex items-center gap-2 font-mono2 text-[11px] tracking-[0.2em] uppercase text-[#FFE600]">
              <span className="w-2 h-2 rounded-full bg-[#FFE600] animate-pulse-dot" />
              Express-Service verfügbar
            </div>
          </div>

          <div className="md:col-span-2">
            <p className="font-mono2 text-[11px] tracking-[0.25em] uppercase text-gray-500 mb-5">Navigation</p>
            <ul className="space-y-3 text-sm">
              <li><Link data-testid="footer-link-start" to="/" className="text-gray-300 hover:text-[#FFE600] transition-colors">Start</Link></li>
              <li><Link data-testid="footer-link-leistungen" to="/leistungen" className="text-gray-300 hover:text-[#FFE600] transition-colors">Leistungen</Link></li>
              <li><Link data-testid="footer-link-ueber-uns" to="/ueber-uns" className="text-gray-300 hover:text-[#FFE600] transition-colors">Über uns</Link></li>
              <li><Link data-testid="footer-link-kontakt" to="/kontakt" className="text-gray-300 hover:text-[#FFE600] transition-colors">Kontakt</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono2 text-[11px] tracking-[0.25em] uppercase text-gray-500 mb-5">Kontakt</p>
            <ul className="space-y-4 text-sm">
              <li>
                <a data-testid="footer-phone-link" href="tel:+4915116012024" className="flex items-start gap-3 text-gray-300 hover:text-[#FFE600] transition-colors">
                  <Phone className="w-4 h-4 mt-0.5 text-[#FFE600]" />
                  0151 16012024
                </a>
              </li>
              <li>
                <a data-testid="footer-email-link" href="mailto:info@hero-phone.de" className="flex items-start gap-3 text-gray-300 hover:text-[#FFE600] transition-colors">
                  <Mail className="w-4 h-4 mt-0.5 text-[#FFE600]" />
                  info@hero-phone.de
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-300">
                <MapPin className="w-4 h-4 mt-0.5 text-[#FFE600]" />
                <span>
                  Dorfstraße 70A
                  <br />
                  21775 Odisheim
                </span>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="font-mono2 text-[11px] tracking-[0.25em] uppercase text-gray-500 mb-5">Rechtliches</p>
            <ul className="space-y-3 text-sm">
              <li><Link data-testid="footer-link-impressum" to="/impressum-agb" className="text-gray-300 hover:text-[#FFE600] transition-colors">Impressum &amp; AGB</Link></li>
              <li><Link data-testid="footer-link-datenschutz" to="/datenschutzerklaerung" className="text-gray-300 hover:text-[#FFE600] transition-colors">Datenschutz</Link></li>
            </ul>
            <p className="mt-6 text-xs text-gray-500 leading-relaxed">
              Termine nach Vereinbarung – ruf einfach an.
            </p>
          </div>
        </div>

        <div className="select-none pointer-events-none" aria-hidden="true">
          <p className="font-display font-extrabold uppercase leading-[0.8] text-[18vw] md:text-[11rem] text-outline-white opacity-[0.08] whitespace-nowrap">
            HeroPhone
          </p>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row justify-between gap-3">
          <p className="text-xs text-gray-500">© 2026 HeroPhone · Inhaber: Ricardo Galindo Cuenca</p>
          <p className="font-mono2 text-[11px] tracking-[0.2em] uppercase text-gray-600">
            1h Express · 90 Tage Garantie
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
